import { SearchTerm } from './SearchTerm';

const CardFormatsSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "trnName",
        translationKey: "name"
    },
    {
        heading: "Tag Mask",
        accessor: "tagMask",
        searchOnName: "tfTagMask",
        translationKey: "tagmask"
    },
    {
        heading: "Site Mask",
        accessor: "siteMask",
        searchOnName: "tfSiteMask",
        translationKey: "siteMask"
    }
];

export default CardFormatsSearch;
